<template>
  <div class="c-stepper">
    <div class="step" :class="{active:value===1}">
      <span>1</span>
      填写投保资料
    </div>
    <div class="step" :class="value===2?'active active-in':'active-out'">
      <span>2</span>
      支付保费
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: 1
    }
  }
};
</script>

<style lang="scss" scoped>
.c-stepper {
  display: flex;
  font-size: 14px;
  background-color: $bg-light-color;
  margin-bottom: 24px;
  .step {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 188px;
    height: 38px;
    line-height: 38px;
    span {
      display: inline-block;
      width: 13px;
      height: 13px;
      font-size: 13px;
      line-height: 13px;
      text-align: center;
      background-color: $bg-dark-color;
      color: $light-color;
      margin-right: 0.5em;
    }
  }
  .active {
    background-color: $primary-color;
    color: $light-color;
    span {
      background-color: $bg-light-color;
      color: $primary-color;
    }
  }
  .active-in {
    border-width: 19px;
    border-style: solid;
    border-color: transparent transparent transparent $bg-light-color;
  }
  .active-out {
    border-width: 19px;
    border-style: solid;
    border-color: transparent transparent transparent $primary-color;
  }
}
</style>
